// src/components/Logs/LogsFilter.js
import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  TextField,
  Button,
  MenuItem,
  Box
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

const LogsFilter = ({ filtros, onChange, onApply }) => {
  const handleChange = (field) => (event) => {
    onChange({
      ...filtros,
      [field]: event.target.value
    });
  };

  const handleDateChange = (field) => (date) => {
    onChange({
      ...filtros,
      [field]: date
    });
  };

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} sm={6} md={2}>
        <TextField
          fullWidth
          select
          label="Tipo de Log"
          value={filtros.tipoLog}
          onChange={handleChange('tipoLog')}
        >
          <MenuItem value="">Todos</MenuItem>
          <MenuItem value="SISTEMA">Sistema</MenuItem>
          <MenuItem value="SEGURANCA">Segurança</MenuItem>
          <MenuItem value="NEGOCIO">Negócio</MenuItem>
        </TextField>
      </Grid>

      <Grid item xs={12} sm={6} md={2}>
        <TextField
          fullWidth
          select
          label="Sensibilidade"
          value={filtros.nivelSensibilidade}
          onChange={handleChange('nivelSensibilidade')}
        >
          <MenuItem value="">Todos</MenuItem>
          <MenuItem value="BAIXO">Baixo</MenuItem>
          <MenuItem value="MEDIO">Médio</MenuItem>
          <MenuItem value="ALTO">Alto</MenuItem>
        </TextField>
      </Grid>

      <Grid item xs={12} sm={6} md={2}>
        <DatePicker
          label="Data Início"
          value={filtros.dataInicio}
          onChange={handleDateChange('dataInicio')}
          renderInput={(params) => <TextField {...params} fullWidth />}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={2}>
        <DatePicker
          label="Data Fim"
          value={filtros.dataFim}
          onChange={handleDateChange('dataFim')}
          renderInput={(params) => <TextField {...params} fullWidth />}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={2}>
        <TextField
          fullWidth
          label="Ação"
          value={filtros.acao}
          onChange={handleChange('acao')}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={2}>
        <Box display="flex" gap={1}>
          <Button
            variant="contained"
            color="primary"
            onClick={onApply}
            fullWidth
          >
            Aplicar
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              onChange({
                tipoLog: '',
                nivelSensibilidade: '',
                dataInicio: null,
                dataFim: '',
                acao: '',
                entidade: ''
              });
              onApply();
            }}
            fullWidth
          >
            Limpar
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

LogsFilter.propTypes = {
  filtros: PropTypes.shape({
    tipoLog: PropTypes.string,
    nivelSensibilidade: PropTypes.string,
    dataInicio: PropTypes.instanceOf(Date),
    dataFim: PropTypes.instanceOf(Date),
    acao: PropTypes.string,
    entidade: PropTypes.string
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired
};

LogsFilter.defaultProps = {
  filtros: {
    tipoLog: '',
    nivelSensibilidade: '',
    dataInicio: null,
    dataFim: null,
    acao: '',
    entidade: ''
  }
};

export default LogsFilter;
